import { createSlice } from '@reduxjs/toolkit';

const toggleItem = (list, id) => {
  const index = list.findIndex((prod) => prod === id);
  if (index !== -1) {
    list.splice(index, 1);
  } else {
    list.push(id);
  }

  return [...list];
};

const getAmount = (amounts, id) => {
  return amounts.hasOwnProperty(id) ? amounts[id] : undefined;
};

const inCart = (cart, id) => {
  return cart.find((p) => p.id === id);
};

const changeAmount = (amounts, id, q, replace = false) => {
  if (!amounts.hasOwnProperty(id)) {
    amounts[id] = 0;
  }
  let newAmount = replace ? q : amounts[id] + q;
  if (newAmount <= 0) {
    return amounts;
  }

  if (Number.isInteger(newAmount)) {
    amounts[id] = newAmount;
  } else {
    amounts[id] = Number(newAmount.toFixed(2));
  }

  return Object.assign({}, amounts);
};

export const prod = createSlice({
  name: 'prod',
  initialState: {
    cart: [],
    amounts: {},
    favour: [],
    compare: [],
    blank: 0,
  },

  reducers: {
    reset: (state) => {
      state.cart = [];
      return state;
    },

    addCartItem: (state, { payload }) => {
      const { id, q } = payload;
      const { cart, amounts } = state;

      if (inCart(cart, id)) {
        return state;
      }

      let amount = getAmount(amounts, id);
      if (amount === undefined) {
        const newAmounts = changeAmount(amounts, id, q);
        amount = getAmount(newAmounts, id);
        state.amounts = newAmounts;
      }
      cart.push({ id, q: amount });

      state.cart = [...cart];
      return state;
    },

    rmCartItem: (state, { payload: id }) => {
      const { cart } = state;
      const index = cart.findIndex((prod) => prod.id === id);
      if (index !== -1) {
        cart.splice(index, 1);
      }

      state.cart = [...cart];
      return state;
    },

    minus: (state, { payload }) => {
      const { id, q } = payload;
      const { cart, amounts } = state;

      let amount = getAmount(amounts, id);
      if (amount === q || amount === undefined) {
        return state;
      }

      const newAmounts = changeAmount(amounts, id, -q);
      state.amounts = newAmounts;

      if (inCart(cart, id)) {
        const index = cart.findIndex((prod) => prod.id === id);
        cart[index].q = newAmounts[id];
        state.cart = [...cart];
      }

      return state;
    },

    plus: (state, { payload }) => {
      const { id, q } = payload;
      const { cart, amounts } = state;

      let amount = q;
      if (getAmount(amounts, id) === undefined) {
        amount = amount * 2;
      }
      const newAmounts = changeAmount(amounts, id, amount);
      state.amounts = newAmounts;

      if (inCart(cart, id)) {
        const index = cart.findIndex((prod) => prod.id === id);
        cart[index].q = newAmounts[id];
        state.cart = [...cart];
      }

      return state;
    },

    setAmount: (state, { payload }) => {
      const { id, q } = payload;
      const { cart, amounts } = state;

      const newAmounts = changeAmount(amounts, id, q, true);
      state.amounts = newAmounts;

      if (inCart(cart, id)) {
        const index = cart.findIndex((prod) => prod.id === id);
        cart[index].q = newAmounts[id];
        state.cart = [...cart];
      }

      return state;
    },

    clearCart: (state) => {
      state.cart = [];
      return state;
    },

    clearAmounts: (state) => {
      state.amounts = {};
      return state;
    },

    favour: (state, { payload }) => {
      state.favour = toggleItem(state.favour, payload);
      return state;
    },

    clearFavour: (state) => {
      state.favour = [];
      return state;
    },

    compare: (state, { payload }) => {
      state.compare = toggleItem(state.compare, payload);
      return state;
    },

    clearCompare: (state) => {
      state.compare = [];
      return state;
    },

    blankUpdate: (state) => {
      const { blank } = state;
      state.blank = blank + 1;
      return state;
    },
  },
});

export default prod.reducer;
